// @flow
import type { AxiosPromise, AxiosInstance } from "axios";
import type { RotateListingPhotoUploadItem } from "../types";

const listingUploadPhotoRotate = (
  listingId: number,
  photoId: number,
  rotation: number
): ((
  apiInstance: AxiosInstance
) => AxiosPromise<RotateListingPhotoUploadItem>) => (apiInstance) => {
  return apiInstance.patch(`/v4/listings/${listingId}/upload/${photoId}`, {
    rotation
  });
};

export default listingUploadPhotoRotate;
